

export default {
  name: 'AcademyCardTestimonial',
  props: {
    logo: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Vendula',
    },
    description: {
      type: String,
      default:
        '3D FITNESS GYM je silně návykové místo, kam se člověku chce jít v 7 ráno i v 8 večer a je vám líto, když zrovna na tu vaší oblíbenou lekci nemůžete jít. 3DFA pro mě neni fitness centrum (tam bych asi nikdy nechodila), ale kamarádi, na které se pokaždé těším, kteří mě dobijou baterky a spolehlivě dodají dobrou náladu. Super fyzička se postupně stala vedlejším efektem mých pravidelných návštěv. 3DFA pro mě znamená naprosto srdcovou záležitost. ',
    },
    courses: {
      type: Array,
      required: true,
    },
    trainers: {
      type: Array,
      required: true,
    },
  },
  computed: {
    generatedLogo() {
      if (!this.logo) {
        return ''
      }
      return `${this.logo}`
    },
  },
}
